import React from "react";
import CommonImageSlider from "./comandata";
import { eamcetCourse, homeImages, studentsRanks } from "./data";
import CallandRegisterComponent from "./Callbutton";
import EamcetLongTerm from "./subcomponents/EamcetLongTerm";
import CommonImageSliderRanks from "./CommonsliderRanks";

const EapcetSection = () => {
  return (
    <div>
      {/* <section>
        <p className="text-xl sm:text-xl text-[#20b2aa] font-extrabold text-center mb-12">
          Best EAMCET (EAPCET) Long Term Coaching in Hyderabad | Top EAPCET Training for Intermediate Students
      </p>
        <CommonImageSliderRanks images={studentsRanks}/>
        <CallandRegisterComponent />
      </section>
      <CommonImageSlider images={eamcetCourse}/>
       <div className="mb-10 mt-8 me-2 ms-2">
<CallandRegisterComponent /> */}
<EamcetLongTerm />

</div>
    
      

  );
};

export default EapcetSection;
